import ApplicationSerializer from 'cio/serializers/application';
import DS from 'ember-data';

const { EmbeddedRecordsMixin } = DS;

export default class ApiCredentialSerializer extends ApplicationSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    // Don't send environment ID in the request body: it's ignored by the API anyway, which reads it from the URL
    environment: {
      serialize: false,
    },
  },
}) {}
